import { render } from "./LeagueBar.vue?vue&type=template&id=548b3edc&scoped=true"
import script from "./LeagueBar.vue?vue&type=script&lang=js"
export * from "./LeagueBar.vue?vue&type=script&lang=js"

import "./LeagueBar.vue?vue&type=style&index=0&id=548b3edc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548b3edc"]])

export default __exports__